export const translations = {
    en: {
        dashboard: {
            title: 'Live Dashboard',
            playback: 'Playback View',
            detailed: 'Detailed Data',
            boatId: 'Boat ID',
            lastUpdate: 'Last Update',
            live: 'Live',
            navigation: 'Navigation',
            latitude: 'Latitude',
            longitude: 'Longitude',
            heading: 'Heading',
            refresh: 'Refresh Data',
            settings: 'Sensor Settings',
            switchView: 'Switch View',
            close: 'Close'
        },
        sensors: {
            temp: 'Temperature',
            wt: 'Water temp (sensor)',
            wtFc: 'Water temp (forecast)',
            ph: 'pH Level',
            o2: 'Dissolved O₂',
            nh4: 'NH₄⁺',
            turbidity: 'Turbidity',
            clarity: 'Clarity',
            t1: 'Temp 1',
            t2: 'Temp 2',
            t3: 'Temp 3',
            t4: 'Temp 4',
            t5: 'Temp 5',
            bat: 'Phone Battery',
            vbat: 'System Battery',
            soc: 'Charge',
            wifiDbm: 'WiFi',
            cellDbm: 'Cell',
            phpa: 'Pressure',
            wind: 'Wind (forecast)',
            windKmh: 'Wind (km/h)'
        },
        settings: {
            title: 'Sensor Settings',
            subtitle: 'Toggle visibility of sensors on the dashboard',
            water: 'Water Quality',
            temp: 'Temperature Array',
            system: 'System Status',
            env: 'Environment',
            save: 'Save Changes',
            cancel: 'Cancel'
        },
        playback: {
            controls: 'Playback Controls',
            play: 'Play',
            pause: 'Pause',
            speed: 'Speed',
            export: 'Export CSV',
            selectDate: 'Select Date Range',
            manual: 'Manual Range',
            start: 'Start Date & Time',
            end: 'End Date & Time',
            load: 'Load Data',
            loading: 'Loading...',
            sessions: 'Available Sessions',
            noSessions: 'No recorded sessions found.',
            noData: 'No playback data loaded'
        },
        liveBanner: {
            boatsLive: 'boats live now',
            switchToLive: 'Switch to Live'
        }
    },
    lt: {
        dashboard: {
            title: 'Tiesioginis Skydelis',
            playback: 'Peržiūros Režimas',
            detailed: 'Išsamūs Duomenys',
            boatId: 'Laivo ID',
            lastUpdate: 'Paskutinis Atnaujinimas',
            live: 'Tiesiogiai',
            navigation: 'Navigacija',
            latitude: 'Platuma',
            longitude: 'Ilguma',
            heading: 'Kursas',
            refresh: 'Atnaujinti',
            settings: 'Jutiklių Nustatymai',
            switchView: 'Keisti Rodinį',
            close: 'Uždaryti'
        },
        sensors: {
            temp: 'Temperatūra',
            wt: 'Vandens temp. (jutiklis)',
            wtFc: 'Vandens temp. (prognozė)',
            ph: 'pH Lygis',
            o2: 'Ištirpęs O₂',
            nh4: 'NH₄⁺',
            turbidity: 'Drumstumas',
            clarity: 'Skaidrumas',
            t1: 'Temp 1',
            t2: 'Temp 2',
            t3: 'Temp 3',
            t4: 'Temp 4',
            t5: 'Temp 5',
            bat: 'Telefono Baterija',
            vbat: 'Sistemos Baterija',
            soc: 'Įkrova',
            wifiDbm: 'WiFi',
            cellDbm: 'Ryšys',
            phpa: 'Slėgis',
            wind: 'Vėjas (prognozė)',
            windKmh: 'Vėjas (km/h)'
        },
        settings: {
            title: 'Jutiklių Nustatymai',
            subtitle: 'Įjungti/išjungti jutiklių matomumą',
            water: 'Vandens Kokybė',
            temp: 'Temperatūrų Masyvas',
            system: 'Sistemos Būsena',
            env: 'Aplinka',
            save: 'Išsaugoti',
            cancel: 'Atšaukti'
        },
        playback: {
            controls: 'Peržiūros Valdymas',
            play: 'Groti',
            pause: 'Pauzė',
            speed: 'Greitis',
            export: 'Eksportuoti CSV',
            selectDate: 'Pasirinkti Datą',
            manual: 'Rankinis Pasirinkimas',
            start: 'Pradžios Data ir Laikas',
            end: 'Pabaigos Data ir Laikas',
            load: 'Užkrauti Duomenis',
            loading: 'Kraunama...',
            sessions: 'Galimos Sesijos',
            noSessions: 'Įrašytų sesijų nerasta.',
            noData: 'Nėra užkrautų duomenų'
        },
        liveBanner: {
            boatsLive: 'laivų tiesiogiai',
            switchToLive: 'Rodyti Tiesiogiai'
        }
    }
}

export type Language = 'en' | 'lt'
export type TranslationKey = keyof typeof translations.en
